'use strict';

module.exports = /\(([-+]\d{2,4}|\w{3,5})\)$/;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/var/TIMEZONE_ABBREVIATION_REG.js
// module id = 607
// module chunks = 0